import gql from "graphql-tag";

export default gql`
  query FinancialBusinessSegments($tickerSymbol: TickerSymbol!) {
    financialBusinessSegments(tickerSymbol: $tickerSymbol) {
      periodEndingDate
      currency
      reportSource {
        accessionNumber
        primaryDocumentHref
      }
      segments {
        name
        isPrimary
        ratioAdjustedIndicators {
          name
          value
          history {
            periodEndingDate
            value
          }
        }
        financialIndicators {
          name
          value
          history {
            periodEndingDate
            value
          }
        }
      }
      adjustedTotals {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
      unadjustedTotals {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
      revenueHistory {
        periodEndingDate
        value
      }
    }
  }
`;
